<template>
  <!-- <p>{{ $t("message.hello") }}</p> -->
  <!-- --{{ store.state.message }}-- -->
  <router-view />
  <Fallback/>

</template>

<script>
import Fallback from '@/components/Fallback'
// console.log(store.state);
export default {
  name: 'App',
  components: {
    Fallback
  },
  inject: ['store'],
  // setup() {
  //   return {
  //     store
  //   }
  // }
  // data() {
  //   return {
  //     sharedState: store.state
  //   }
  // },
}
</script>

<style lang="stylus">
@font-face
  font-family "FuturaStd"
  src local("FuturaStd"),
   url(./assets/fonts/FuturaStd-Book.woff) format("woff"),
   url(./assets/fonts/FuturaStd-Book.woff2) format("woff2")
  font-weight normal

@font-face
  font-family "FuturaStd-bold"
  src local("FuturaStd"),
   url(./assets/fonts/FuturaStd-Bold.woff) format("woff"),
   url(./assets/fonts/FuturaStd-Bold.woff2) format("woff2")
  font-weight bold

a:focus
input:focus
  outline none

body, html
  height 100%
  overflow hidden
  font-family FuturaStd, Arial, sans-serif
  background black
  color white


  #app
    // font-family: Avenir, Helvetica, Arial, sans-serif;
    // -webkit-font-smoothing: antialiased;
    // -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    // color: #2c3e50;
    // margin-top: 60px;
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    overflow auto
    min-height 800px

</style>
